import { render, staticRenderFns } from "./addRole.vue?vue&type=template&id=57304834&scoped=true"
import script from "./addRole.vue?vue&type=script&lang=js"
export * from "./addRole.vue?vue&type=script&lang=js"
import style0 from "./addRole.vue?vue&type=style&index=0&id=57304834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57304834",
  null
  
)

export default component.exports